import { render } from "./javaScriptBehavior.vue?vue&type=template&id=a42368fa"
import script from "./javaScriptBehavior.vue?vue&type=script&lang=js"
export * from "./javaScriptBehavior.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__